/* eslint-disable @typescript-eslint/no-var-requires */
import { APP_URL, THEME_NAME } from 'utils/helperConfig'

import { availableCards as themeCards } from './cards'
import { theme, themeVariables } from './Provider'

const STYLES_PATH = file => {
    try {
        return require(`./${THEME_NAME}${file}`)
    } catch {
        return require(`./base${file}`)
    }
}

const styles = require(`./${THEME_NAME}/styles`)
const newUseTheme = require(`./${THEME_NAME}/useTheme`)
const globalStyles = STYLES_PATH('/global-styles')
let textFieldVariant
let formControlVariant
let CompanyApplicationForm_Version
let IndividualApplicationForm_Version

let BRAND_NAME
let COMPANY_NAME
let COMPANY_NUMBER
let MEMBER_NUMBER
let SUPPORT_EMAIL
let CONTACT_STREET
let CONTACT_CITY
let CONTACT_POSTCODE
let CONTACT_COUNTRY
let CONTACT_PHONE
let LANDING_URL
let LEGAL_HEADER_NAVBAR = true
let DOMAIN_WITHOUT_ALIAS
const ANALYTICS_TOGGLE_ENABLED = false
let ANALYTICS_GTAG_ID
let ANALYTICS_GTM_ID

if (THEME_NAME === 'development') {
    textFieldVariant = 'outlined'
    formControlVariant = 'outlined'
    IndividualApplicationForm_Version = 'v2'
    CompanyApplicationForm_Version = 'v2'

    BRAND_NAME = 'Development'
    COMPANY_NAME = 'Development'
    COMPANY_NUMBER = '2424461.01'
    MEMBER_NUMBER = ''
    SUPPORT_EMAIL = 'support@swisstech.dev'
    CONTACT_STREET = 'Meydan Grandstand'
    CONTACT_CITY = 'Dubai'
    CONTACT_POSTCODE = 'PO Box 121001'
    CONTACT_COUNTRY = 'U.A.E.'
    DOMAIN_WITHOUT_ALIAS = 'swisstech.dev'
}

if (THEME_NAME === 'playground') {
    // textFieldVariant = 'standard';
    // formControlVariant = 'standard';
    textFieldVariant = 'outlined'
    formControlVariant = 'outlined'
    IndividualApplicationForm_Version = 'v2'
    CompanyApplicationForm_Version = 'v2'

    BRAND_NAME = 'SWISSTECH'
    COMPANY_NAME = 'SWISSTECH LLC'
    MEMBER_NUMBER = '1291'
    COMPANY_NUMBER = '2424461.01'
    SUPPORT_EMAIL = 'support@swisstech.dev'
    CONTACT_STREET = 'Meydan Grandstand'
    CONTACT_CITY = 'Dubai'
    CONTACT_POSTCODE = 'PO Box 121001'
    CONTACT_COUNTRY = 'U.A.E.'
    LANDING_URL = 'https://swisstech.dev'
    LEGAL_HEADER_NAVBAR = false
    DOMAIN_WITHOUT_ALIAS = 'swisstech.dev'
}

if (THEME_NAME === 'swisstech') {
    textFieldVariant = 'outlined'
    formControlVariant = 'outlined'
    IndividualApplicationForm_Version = 'v2'
    CompanyApplicationForm_Version = 'v2'

    BRAND_NAME = 'SWISSTECH'
    COMPANY_NAME = 'SWISSTECH LLC'
    MEMBER_NUMBER = '1291'
    COMPANY_NUMBER = '2424461.01'
    SUPPORT_EMAIL = 'support@swisstech.dev'
    CONTACT_STREET = 'Meydan Grandstand'
    CONTACT_CITY = 'Dubai'
    CONTACT_POSTCODE = 'PO Box 121001'
    CONTACT_COUNTRY = 'U.A.E.'
    LANDING_URL = 'https://swisstech.dev'
    LEGAL_HEADER_NAVBAR = true
    DOMAIN_WITHOUT_ALIAS = 'swisstech.dev'
}

export const themeConfig = {
    BRAND_NAME,
    COMPANY_NAME,
    COMPANY_NUMBER,
    MEMBER_NUMBER,
    SUPPORT_EMAIL,
    CONTACT_STREET,
    CONTACT_CITY,
    CONTACT_POSTCODE,
    CONTACT_COUNTRY,
    IndividualApplicationForm_Version,
    CompanyApplicationForm_Version,
    CONTACT_PHONE,
    APP_URL,
    LANDING_URL,
    LEGAL_HEADER_NAVBAR,
    DOMAIN_WITHOUT_ALIAS,
    ANALYTICS_TOGGLE_ENABLED,
    ANALYTICS_GTAG_ID,
    ANALYTICS_GTM_ID,
}

export const IMAGES_PATH = file => {
    try {
        try {
            return require(`./${THEME_NAME}/assets/images${file}`)
        } catch {
            return require(`./base/assets/images${file}`)
        }
    } catch {
        return require('./base/assets/images/generic.svg')
    }
}

export const THEME_IMAGES_PATH = file => {
    try {
        return require(`./${THEME_NAME}/assets/images${file}`)
    } catch {
        return null
    }
}

export const LANDING_IMAGES_PATH = file => require(`./${THEME_NAME}/assets/landing/images${file}`)

export const ASSETS_PATH = file => {
    try {
        return require(`./${THEME_NAME}/assets${file}`)
    } catch {
        return require(`./base/assets${file}`)
    }
}

export const UPLOADS_PATH = file => require(`./${THEME_NAME}/uploads${file}`)

export const useTheme = newUseTheme?.useTheme
export const styledComponentsTheme = newUseTheme?.styledComponentsTheme
export const GlobalStyles = globalStyles?.VerificationGlobalStyles
export const TextFieldVariant = textFieldVariant
export const FormControlVariant = formControlVariant
export const availableCards = themeCards
export const themeStyles = { ...styles }
export { theme, themeVariables }
